(function($){

  $.fn.twentytwenty = function(options) {
    var options = $.extend({
      default_offset_pct: 0.75,
      orientation: 'horizontal',
      before_label: 'Before',
      after_label: 'After',
      no_overlay: false,
      move_slider_on_hover: false,
      move_with_handle_only: true,
      click_to_move: false,
      // ── IntersectionObserver reveal options ──
      reveal_on_scroll: false,
      reveal_offset_pct: 0.20,
      reveal_threshold: 0.5,
      reveal_duration: 800,
      reveal_label: 'After'
    }, options);

    return this.each(function() {

      var sliderPct = options.default_offset_pct;
      var container = $(this);
      var sliderOrientation = options.orientation;
      var beforeDirection = (sliderOrientation === 'vertical') ? 'down' : 'left';
      var afterDirection = (sliderOrientation === 'vertical') ? 'up' : 'right';

      container.wrap("<div class='twentytwenty-wrapper twentytwenty-" + sliderOrientation + "'></div>");
      if (!options.no_overlay) {
        container.append("<div class='twentytwenty-overlay'></div>");
        var overlay = container.find(".twentytwenty-overlay");
        overlay.append("<div class='twentytwenty-before-label show' data-content='" + options.before_label + "'></div>");
        overlay.append("<div class='twentytwenty-after-label show' data-content='" + options.after_label + "'></div>");
      }
      var beforeImg = container.find("img:first");
      var afterImg = container.find("img:last");
      var beforeOverlay = container.find(".before-image-overlay");
      container.append("<div class='twentytwenty-handle'></div>");
      var slider = container.find(".twentytwenty-handle");
      slider.append("<span class='twentytwenty-" + beforeDirection + "-arrow'></span>");
      slider.append("<span class='twentytwenty-" + afterDirection + "-arrow'></span>");
      container.addClass("twentytwenty-container");
      beforeImg.addClass("twentytwenty-before");
      afterImg.addClass("twentytwenty-after");

      // Label edges — null until first movestart when labels are guaranteed visible
      var beforeEdge = null;
      var afterEdge  = null;

      var measureEdges = function() {
        var beforeEl   = container.find('.twentytwenty-before-label')[0];
        var afterEl    = container.find('.twentytwenty-after-label')[0];
        var beforeRight = parseFloat(getComputedStyle(beforeEl, '::before').right);
        var imgW        = beforeImg.width();
        beforeEdge      = imgW - beforeRight;
        afterEdge       = parseFloat(getComputedStyle(afterEl, '::before').left);
      };

      var calcOffset = function(dimensionPct) {
        var w = beforeImg.width();
        var h = beforeImg.height();
        return {
          w: w + "px",
          h: h + "px",
          cw: (dimensionPct * w) + "px",
          ch: (dimensionPct * h) + "px"
        };
      };

      var adjustContainer = function(offset) {
        if (sliderOrientation === 'vertical') {
          beforeImg.css("clip", "rect(0," + offset.w + "," + offset.ch + ",0)");
          afterImg.css("clip", "rect(" + offset.ch + "," + offset.w + "," + offset.h + ",0)");
        } else {
          beforeImg.css("clip", "rect(0," + offset.cw + "," + offset.h + ",0)");
          afterImg.css("clip", "rect(0," + offset.w + "," + offset.h + "," + offset.cw + ")");
        }
        if (beforeOverlay.length) {
          // Keep the before-image overlay clipped to exactly the same
          // visible region as the before image, so it never bleeds onto
          // the after image as the handle is dragged.
          beforeOverlay.css({
            width: offset.w,
            height: offset.h,
            clip: (sliderOrientation === 'vertical')
              ? "rect(0," + offset.w + "," + offset.ch + ",0)"
              : "rect(0," + offset.cw + "," + offset.h + ",0)"
          });
        }
        container.css("height", offset.h);
      };

      var adjustSlider = function(pct) {
        var offset = calcOffset(pct);
        slider.css(
          (sliderOrientation === "vertical") ? "top" : "left",
          (sliderOrientation === "vertical") ? offset.ch : offset.cw
        );
        adjustContainer(offset);

        // Only toggle labels if edges have been measured (i.e. after first drag)
        if (!options.no_overlay && sliderOrientation !== 'vertical' && beforeEdge !== null) {
          var handleLeft = pct * beforeImg.width();
          container.find('.twentytwenty-before-label').toggleClass('show', handleLeft > beforeEdge);
          container.find('.twentytwenty-after-label').toggleClass('show', handleLeft < afterEdge);
        }
      };

      var minMaxNumber = function(num, min, max) {
        return Math.max(min, Math.min(max, num));
      };

      var getSliderPercentage = function(positionX, positionY) {
        var sliderPercentage = (sliderOrientation === 'vertical') ?
          (positionY - offsetY) / imgHeight :
          (positionX - offsetX) / imgWidth;
        return minMaxNumber(sliderPercentage, 0, 1);
      };

      $(window).on("resize.twentytwenty", function(e) {
        beforeEdge = null;
        afterEdge  = null;
        adjustSlider(sliderPct);
      });

      var offsetX = 0;
      var offsetY = 0;
      var imgWidth = 0;
      var imgHeight = 0;

      var onMoveStart = function(e) {
        if (((e.distX > e.distY && e.distX < -e.distY) || (e.distX < e.distY && e.distX > -e.distY)) && sliderOrientation !== 'vertical') {
          e.preventDefault();
        } else if (((e.distX < e.distY && e.distX < -e.distY) || (e.distX > e.distY && e.distX > -e.distY)) && sliderOrientation === 'vertical') {
          e.preventDefault();
        }
        container.addClass("active");
        offsetX = container.offset().left;
        offsetY = container.offset().top;
        imgWidth = beforeImg.width();
        imgHeight = beforeImg.height();
        // Measure edges here — labels are always visible at this point
        if (beforeEdge === null) { measureEdges(); }
      };

      var onMove = function(e) {
        if (container.hasClass("active")) {
          sliderPct = getSliderPercentage(e.pageX, e.pageY);
          adjustSlider(sliderPct);
        }
      };

      var onMoveEnd = function() {
        container.removeClass("active");
      };

      var moveTarget = options.move_with_handle_only ? slider : container;
      moveTarget.on("movestart", onMoveStart);
      moveTarget.on("move", onMove);
      moveTarget.on("moveend", onMoveEnd);

      if (options.move_slider_on_hover) {
        container.on("mouseenter", onMoveStart);
        container.on("mousemove", onMove);
        container.on("mouseleave", onMoveEnd);
      }

      slider.on("touchmove", function(e) {
        e.preventDefault();
      });

      container.find("img").on("mousedown", function(event) {
        event.preventDefault();
      });

      if (options.click_to_move) {
        container.on('click', function(e) {
          offsetX = container.offset().left;
          offsetY = container.offset().top;
          imgWidth = beforeImg.width();
          imgHeight = beforeImg.height();
          if (beforeEdge === null) { measureEdges(); }
          sliderPct = getSliderPercentage(e.pageX, e.pageY);
          adjustSlider(sliderPct);
        });
      }

      $(window).trigger("resize.twentytwenty");

      // ── IntersectionObserver reveal on scroll ──────────────────────────────
      if (options.reveal_on_scroll && typeof IntersectionObserver !== 'undefined') {

        var animateSlider = function(fromPct, toPct, duration) {
          var start = null;
          var step = function(timestamp) {
            if (!start) start = timestamp;
            var progress = Math.min((timestamp - start) / duration, 1);
            var ease = progress < 0.5
              ? 4 * progress * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 3) / 2;
            sliderPct = fromPct + (toPct - fromPct) * ease;
            adjustSlider(sliderPct);
            if (progress < 1) {
              requestAnimationFrame(step);
            } else if (options.reveal_label) {
              var flash = $("<div class='twentytwenty-reveal-label'></div>")
                .text(options.reveal_label)
                .appendTo(container);
              setTimeout(function() { flash.addClass('visible'); }, 50);
              setTimeout(function() {
                flash.removeClass('visible');
                setTimeout(function() { flash.remove(); }, 350);
              }, 2000);
            }
          };
          requestAnimationFrame(step);
        };

        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              animateSlider(sliderPct, options.reveal_offset_pct, options.reveal_duration);
              observer.disconnect();
            }
          });
        }, {
          threshold: options.reveal_threshold
        });

        observer.observe(container[0]);
      }
      // ───────────────────────────────────────────────────────────────────────

    });
  };

})(jQuery);